import Vue from 'vue';
import dayjs from 'dayjs';
import {
  errCodeMap,
} from '@/lib/errors';
import * as types from './types';
import api from '@/apis/summary';
import { get } from 'lodash';


const filterInit = {
  orderId: '',
  productId: '',
  saasType: '',
  mediaType: '',
  mediaId: '',
  stime: dayjs()
    .subtract(6, 'day')
    .format('YYYY-MM-DD'),
  etime: dayjs().format('YYYY-MM-DD'),
  isEshop: -1,
  isSettlement: -1,
  contentTypeNewNum: 0,
};

const pageInfoInit = {
  page: 1,
  count: 10,
  total: 0,
};

export default {
  namespaced: true,
  state: {
    table: [],
    filter: {
      ...filterInit,
    },
    pageInfo: {
      ...pageInfoInit,
    },
    timeout: 60 * 1000,
    tableLoading: false,
  },
  mutations: {
    [types.SET_STATISTIC_ORDER_FILTER](state, filter) {
      state.filter = {
        ...state.filter,
        ...filter,
      };
    },
    [types.RESET_STATISTIC_ORDER_FILTER](state) {
      state.filter = {
        ...filterInit,
      };
    },
    [types.SET_TABLE_LIST](state, {
      list,
    }) {
      state.table = list;
    },
    [types.SET_TABLE_PAGE_INFO](state, {
      pageInfo,
    }) {
      state.pageInfo = {
        ...state.pageInfo,
        ...pageInfo,
      };
    },
    [types.RESET_TABLE_PAGE_INFO](state) {
      state.pageInfo = {
        ...pageInfoInit,
      };
    },
  },
  actions: {
    // 获取订单列表
    async fetchOrderList({
      state,
      commit,
    }) {
      const {
        orderId,
        productId,
        saasType,
        mediaType,
        mediaId,
        stime,
        etime,
        isEshop,
        isSettlement,
        contentTypeNewNum,
        channelMedia,
      } = state.filter;

      const data = {
        order_id: orderId,
        product_id: productId,
        saas_type: saasType === '全部' ? '' : saasType,
        media_type: mediaType === '全部' ? '' : mediaType,
        media_id: mediaId === '全部' ? '' : mediaId,
        stime,
        etime,
        page: state.pageInfo.page,
        count: state.pageInfo.count,
        is_eshop_settlement: isEshop.toString() === '-1' ? '' : String(isEshop),
        is_settlement: isSettlement.toString() === '-1' ? '' : String(isSettlement),
        content_type_new: Number(contentTypeNewNum)  || 0,
        timeout: state.timeout,
        channel_media: channelMedia === '全部' ? '' : (channelMedia || ''),
      };
      state.tableLoading = true;
      api.orderDetails(data).then((res) => {
        if (res.head.code !== 0) {
          Vue.prototype.$tip.error(res.head.msg || errCodeMap[res.head.code] || '获取订单列表失败');
        }
        commit(types.SET_TABLE_LIST, {
          list: res.result.list,
        });
        commit(types.SET_TABLE_PAGE_INFO, {
          pageInfo: {
            total: Number(get(res, 'result.page_info.total') || 0),
          },
        });
      })
        .catch(() => {
          Vue.prototype.$tip.error('获取订单列表失败');
        })
        .finally(() => {
          state.tableLoading = false;
        });
    },
    // 导出数据
    async exportOrderStatistic({
      state,
      commit,
    }) {
      const {
        orderId,
        productId,
        saasType,
        mediaType,
        mediaId,
        stime,
        etime,
        isEshop,
        isSettlement,
        contentTypeNewNum,
      } = state.filter;

      const data = {
        order_id: orderId,
        product_id: productId,
        saas_type: saasType === '全部' ? '' : saasType,
        media_type: mediaType === '全部' ? '' : mediaType,
        media_id: mediaId === '全部' ? '' : mediaId,
        stime,
        etime,
        is_eshop_settlement: isEshop.toString() === '-1' ? '' : String(isEshop),
        is_settlement: isSettlement.toString() === '-1' ? '' : String(isSettlement),
        content_type_new: Number(contentTypeNewNum)  || 0,
        timeout: state.timeout,
      };
      api.exportData(data).then((res) => {
        if (res.head.code !== 0) {
          this.$tip.error(res.head.msg || errCodeMap[res.head.status] || '导出数据失败');
          return;
        }
        commit('common/SET_EXPORT_STATUS', {
          biz: 2,
          status: 2,
        }, {
          root: true,
        });
      });
    },
  },
  getters: {},
};
